/**
 * TemplatesModal — template selection grid
 */
import { useBuilderStore } from '@/state/store';
import { industryTemplates } from '@/data/templates';
import { Modal } from './Modal';

export function TemplatesModal() {
  const openModal = useBuilderStore((s) => s.openModal);
  const setOpenModal = useBuilderStore((s) => s.setOpenModal);
  const applyTemplate = useBuilderStore((s) => s.applyTemplate);

  const isOpen = openModal === 'templates';
  const onClose = () => setOpenModal(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Branchen-Template wählen"
      size="lg"
    >
      <p style={{ color: "var(--builder-text-muted)", marginBottom: 20 }}>
        Wähle ein Template als Ausgangspunkt. Deine Änderungen werden überschrieben.
      </p>
      <div className="template-grid">
        {Object.entries(industryTemplates).map(([key, template]) => (
          <button
            key={key}
            className="template-card"
            onClick={() => {
              applyTemplate(key);
              onClose();
            }}
          >
            <div className="template-icon">{(template as any).icon}</div>
            <div className="template-name">{(template as any).name}</div>
            <div className="template-colors">
              <div
                className="template-color"
                style={{ background: (template as any).settings.primaryColor }}
              />
              <div
                className="template-color"
                style={{ background: (template as any).settings.accentColor }}
              />
            </div>
          </button>
        ))}
      </div>
    </Modal>
  );
}
